module.exports = __webpack_public_path__ + "img/Stylized_knife.5ccb922e.png";